import { useCallback } from "react";

import { useCurrentAccountId } from "@zapier/identity";
import { SERVICE_NAME } from "@zapier/utils";

import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

export type FolderDocumentationInteractionOption =
  | "click_assets_tab"
  | "click_documentation_tab"
  | "pin_existing_canvas"
  | "pin_new_canvas"
  | "create_new_canvas"
  | "generate_canvas_from_folder_assets"
  | "regenerate_canvas_from_folder_assets"
  | "generate_ai_notes_from_folder_assets"
  | "regenerate_ai_notes_from_folder_assets"
  | "unpin_canvas"
  | "start_typing_notes"
  | "open_canvas";

interface EmitOptions {
  optionSelected: FolderDocumentationInteractionOption;
  folderId?: string;
  canvasId?: string;
}

export function useEmitFolderDocumentationInteractionEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    ({ optionSelected, folderId, canvasId }: EmitOptions) => {
      emitUserInteractionEvent({
        accountId,
        eventAction: "click",
        interactionName: UserInteractionName.FolderDocumentation,
        optionSelected,
        systemName: SERVICE_NAME,
        customTrackingFields: {
          folder_id: folderId,
          canvas_id: canvasId,
        },
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
